
import { axiosClient, axiosClientWithToken } from "./api.client";

const apiUser = {
    getOTP: async(email) =>{
        try {
            const res = await axiosClient.post(`/user/otp`,{email});
            return res.data;
        } catch (error) {
            console.error('Error fetching', error); 
        }
    },
    postRegister: async(params) =>{
        try {
            const res = await axiosClient.post(`/user/register`,params);
            return res.data;
        } catch (error) {
            console.error('Error fetching', error);
        }
    },
    postLogin: async(params) =>{
        try {
            const res = await axiosClient.post(`/user/login`,params);
            return res.data;
        } catch (error) {
            console.error('Error fetching', error);
        }
    },
    getProfile: async() =>{
        try {
            const res = await axiosClientWithToken.get(`/user/profile`);
            return res.data;
        } catch (error) {
            console.error('Error fetching', error);
        }
    },
    getAllOrders: async() =>{
        try {
            const res = await axiosClientWithToken.get(`/user/order/all`);
            return res.data;
        } catch (error) {
            console.error('Error fetching', error);
        }
    },
    getOrderById: async(id) =>{
        try {
            const res = await axiosClientWithToken.get(`/user/order/${id}`);
            return res.data;
        } catch (error) {
            console.error('Error fetching', error);
        }
    },
    checkEmailAddress: async(email) =>{
        try {
            const res = await axiosClientWithToken.post(`/user/email`,{email});
            return res.data;
        } catch (error) {
            console.error('Error fetching', error);
        }
    },
    logout: async() =>{
        try{
            const res = await axiosClient.get(`/user/logout`);
            return res.data;
        }catch(error){
            console.error('Error fetching', error)
        }
    },
    postUpdateProfile: async(params) =>{
        try{
            const res = await axiosClientWithToken.post(`/user/profile/update`, params)
            return res.data;
        }
        catch(error){
            console.log(error);
        }
    }
}
export default apiUser;